<div class="adjust-panel" [ngStyle]="{ 'max-height': widgetMaxHeight+'px' }" *ngIf="options">
    <div class="control-buttons">
        <dx-button text="Stop" icon="square" [disabled]="!(supplierState | async) || !(isFenixActionEnabled(getCmdRole('StopCmd')) | async)"  (click)="doCommand('StopCmd')" class="stop-button"></dx-button>
        <dx-button text="Start" icon="video" [disabled]="!(supplierState | async) || !(isFenixActionEnabled(getCmdRole('RunCmd')) | async)" (click)="startConfirmDialog()" class="start-button"></dx-button>
        <dx-button text="Empty" [disabled]="!(supplierState | async)" *ngIf="!isEmpting" icon="trash" (onClick)="setEmptyOnSupplier(true)"></dx-button>
        <div class="orange-empty-button" *ngIf="isEmpting">
            <dx-button [disabled]="!(supplierState | async)" text="Empty" icon="trash" (onClick)="setEmptyOnSupplier(false)"></dx-button>
        </div>
    </div>
    <div class="vibrators">
        <h2 class="container-name">VIBRATORS SPEED</h2>
        <div class="row vibrators-edit">
            <div class="col-6 p-0 pr-2">
                <div class="edit-box" *ngIf="speedFixFlowVisibility === 'Visible'">
                    <label for="vibrator-speed">Flow Setup (kg/h)</label>
                    <dx-number-box
                        id="vibrator-speed"
                        format="#0.##"
                        #flowSetupInput
                        [(value)]="viewData.vibrator.flowSetup"
                        [disabled]="productFlowInputDisabled || !(supplierState | async)"
                        [min]="flowSetupMinMax?.min"
                        [max]="flowSetupMinMax?.max"
                        [showSpinButtons]="true"
                        (valueChange)="onSetPropertyInputChange($event, 'productFlowInputDisabled', flowSetupValueStore, flowSetupInput, flowSetupPropertyId)"
                    ></dx-number-box>
                </div>
                <div class="edit-box" *ngIf="speedManualVisibility === 'Visible'">
                    <label for="vibrator-speed">SpeedSet</label>
                    <dx-number-box
                        id="vibrator-speed"
                        format="#0.##"
                        #flowSetupInput
                        [(value)]="viewData.vibrator.speedSet"
                        [disabled]="speedSetInputDisabled || !(supplierState | async)"
                        [min]="speedSetMinMax?.min"
                        [max]="speedSetMinMax?.max"
                        [showSpinButtons]="true"
                        (valueChange)="onSetPropertyInputChange($event, 'speedSetInputDisabled', speedSetValueStore, flowSetupInput, speedSetPropertyId)"
                    ></dx-number-box>
                </div>
            </div>
            <div class="col-6">
                <div class="readonly-box">
                    <label for="vibrator-speed">Actual Flow</label>
                    <div class="value-wrapper">
                        <span class="value">{{viewData.vibrator.actualFlow | number: '1.1-1'}}</span>
                        <span class="unit">kg/h</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="slides-list">
            <div class="slide-item" *ngFor="let slide of viewData.slides; let i = index">
                <h3 class="slide-name">{{slide.slideName}}</h3>
                <div class="edit-box" *ngIf="slide.speedManualVis === 'Visible'">
                    <label for="speed">Speed</label>
                    <dx-number-box
                        #speedInput
                        [id]="'speed-' + i"
                        format="fixedPoint"
                        [(value)]="slide.speed"
                        [min]="slide.speedSetupMinMax?.min"
                        [max]="slide.speedSetupMinMax?.max"
                        [disabled]="slide.speedSetupDisabled || !(supplierState | async) || !(isFenixActionEnabled(slide.speedSetupRole) | async)"
                        (valueChange)="onSetPropertyInputChangeByInputList($event, 'viewData.slides['+ i +'].speedSetupDisabled', slide.speedSetupValueStore ?? 0, 'speed-' + i, speedInputs,slide.speedPropId)"
                        [showSpinButtons]="true"
                    ></dx-number-box>
                </div>
                <div class="edit-box" *ngIf="slide.speedFixFlowVis === 'Visible'">
                    <label for="speed">Flow Setup</label>
                    <dx-number-box
                        #productFlowSetup
                        [id]="'productFlowSetup-' + i"
                        format="#.0"
                        [min]="slide.productFlowSetupMinMax?.min"
                        [max]="slide.productFlowSetupMinMax?.max"
                        [(value)]="slide.productFlowSetup"
                        (valueChange)="onSetPropertyInputChangeByInputList($event, 'viewData.slides['+ i +'].productFlowSetupDisabled', slide.productFlowSetupValueStore ?? 0, 'productFlowSetup-' + i, productFlowSetupInputs, slide.productFlowSetupPropId)"
                        [disabled]="slide.productFlowSetupDisabled || !(supplierState | async)"
                        [showSpinButtons]="true"
                    ></dx-number-box>
                </div>
                <div class="edit-box" *ngIf="slide.speedSectionFixFlowVis === 'Visible'">
                    <label for="speed">Flow Setup</label>
                    <dx-number-box
                        #productFlowSetupFromSection
                        [id]="'productFlowSetupFromSection-' + i"
                        format="#.0"
                        [value]="slide.productFlowSetupFromSection"
                        [disabled]="true"
                        [showSpinButtons]="false"
                    ></dx-number-box>
                </div>
                <div class="readonly-box">
                    <label for="slide-actual-flow">Actual Flow</label>
                    <div class="value-wrapper">
                        <span class="value">{{slide.actualFlow | number: '1.1-1'}}</span>
                        <span class="unit">kg/h</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cameras">
        <h2 class="container-name">CAMERAS PARAM</h2>
        <div class="cameras-edit">
            <div class="row">
                <div class="col-6 p-0">
                    
                    <div class="edit-box">
                        <label for="delay">Delay</label>
                        <dx-number-box
                            id="delay"
                            format="#0"
                            #shiftInput
                            [(value)]="viewData.camera.delay"
                            [min]="shiftMinMax?.min"
                            [max]="shiftMinMax?.max"
                            [disabled]="shiftInputDisabled || !(supplierState | async) || !(isFenixActionEnabled(shiftRole) | async)"
                            (valueChange)="onSetPropertyInputChange($event, 'shiftInputDisabled', shiftValueStore, shiftInput, shiftPropId)"
                            [showSpinButtons]="true"
                        ></dx-number-box>
                    </div>
                </div>
                <div class="col-6 p-0">
                    <div class="edit-box">
                        <label for="min">Min. T. on</label>
                        <dx-number-box
                            id="min"
                            format="#0"
                            #minShootInput
                            [(value)]="viewData.camera.minTimeOn"
                            [min]="minShootMinMax?.min"
                            [max]="minShootMinMax?.max"
                            [disabled]="minShootInputDisabled || !(supplierState | async) || !(isFenixActionEnabled(minShootRole) | async)"
                            (valueChange)="onSetPropertyInputChange($event, 'minShootInputDisabled', minShootValueStore, minShootInput, minShootPropId)"
                            [showSpinButtons]="true"
                        ></dx-number-box>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6 p-0">
                    <div class="edit-box">
                        <label for="grovh">GrowH</label>
                        <dx-number-box
                            id="grovh"
                            format="#0"
                            [(value)]="viewData.camera.growH"
                            [min]="blobHMinMax?.min"
                            [max]="blobHMinMax?.max"
                            #blobHInput
                            [disabled]="blobHAdjustInputDisabled || !(supplierState | async) || !(isFenixActionEnabled(blobHRole) | async)"
                            (valueChange)="onSetPropertyInputChange($event, 'blobHAdjustInputDisabled', blobHAdjustValueStore, blobHInput, blobHAdjustPropId )"
                            [showSpinButtons]="true"
                        ></dx-number-box>
                    </div>
                </div>
                <div class="col-6 p-0">
                    <div class="edit-box">
                        <label for="growv">GrowV</label>
                        <dx-number-box
                            id="growv"
                            format="#0"
                            [(value)]="viewData.camera.growV"
                            [min]="blobVMinMax?.min"
                            [max]="blobVMinMax?.max"
                            #blobVInput
                            [disabled]="blobVAdjustInputDisabled || !(supplierState | async) || !(isFenixActionEnabled(blobVRole) | async)"
                            (valueChange)="onSetPropertyInputChange($event, 'blobVAdjustInputDisabled', blobVAdjustValueStore, blobVInput, blobVAdjustPropId)"
                            [showSpinButtons]="true"
                        ></dx-number-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>